import axios, {AxiosResponse, AxiosError, AxiosRequestConfig} from "axios";

import {Action, ActionCreator} from "redux";
import {Dispatch} from "react-redux";

import {config} from "./Config";
import {IReduxState} from "src/redux/IReduxState";

interface ICallProps {
    data?: any;
    method?: string;
}

export class WebAPI {
    public static getPPNToken(code: string): Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(config.baseURL + "/ppn/token/"+code)
                .then(
                    (response: AxiosResponse) => {
                        if (response != null) {
                            resolve(response.data);
                        }
                        else {
                            reject("no authorization information found in header");
                        }
                    },
                    (e: AxiosError) => {
                        reject(e);
                    });
        });
    }
    public static getAuthUrl(): Promise<string> {
        return new Promise((resolve, reject) => {
            axios.get(config.baseURL + "/ppn/authorization-url")
                .then(
                    (response: AxiosResponse) => {
                        if (response != null) {
                            resolve(response.data.authorization_url);
                        }
                        else {
                            reject("no authorization information found in header");
                        }
                    },
                    (e: AxiosError) => {
                        reject(e);
                    });
        });
    }
    public static getPromtToken(token:string):Promise<string> {
        return new Promise((resolve, reject) => {
            axios.get(config.baseURL + "/auth/callback",{
                headers: {
                    authorization: token ? "Bearer " + token : undefined,
                    "X-Forwarded-Ssl": "on",
                    "PROMT-Host": window.location.hostname,
                  },
            })
                .then(
                    (response: AxiosResponse) => {
                        if (response != null && response.headers != null && response.headers.authorization != null) {
                            if (response != null && response.headers != null && response.headers.authorization != null) {
                                let parts = response.headers.authorization.split(" ");
                                if (parts[0] === "Bearer") {
                                    resolve(parts[1]);
                                }
                                else {
                                    reject("authorization token has wrong format");
                                }
                            }
                            else {
                                reject("authorization token has wrong format");
                            }
                        }
                        else {
                            reject("no authorization information found in header");
                        }
                    },
                    (e: AxiosError) => {
                        reject(e);
                    }).catch((e: AxiosError) => {
                        reject(e);
                    });
        });
    }
    public static slientRefreshToken(refreshtoken:string,token:string):Promise<any> {
        return new Promise((resolve, reject) => {
            axios.get(config.baseURL + `/ppn/token/refresh/${refreshtoken}`,{
                headers: {
                    authorization: token ? "Bearer " + token : undefined,
                    "X-Forwarded-Ssl": "on",
                    "PROMT-Host": window.location.hostname,
                  },
            })
                .then(
                    (response: AxiosResponse) => {
                        if (response != null) {
                            resolve(response.data);
                        }
                        else {
                            reject("no authorization information found in header");
                        }
                    },
                    (e: AxiosError) => {
                        reject(e);
                    });
        });
    }

    public static getForAction<A extends Action, T>(
        route: string,
        state: IReduxState,
        dispatch: Dispatch<IReduxState>,
        actionCreator: ActionCreator<A>,
        data?: any) {
        return this.get<T>(route, state, data)
            .then(
                (result: T) => {
                    dispatch(actionCreator(result));
                    return result;
                },
                (error: string) => console.log(error));
    }

    public static get<T>(
        route: string,
        state: IReduxState,
        data?: any): Promise<T> {
        return this.call<T>(route, state, {data: data, method: "get"});
    }

    public static put<T>(
        route: string,
        state: IReduxState,
        data?: any): Promise<T> {
        return this.call<T>(route, state, {data: data, method: "put"});
    }

    public static post<T>(
        route: string,
        state: IReduxState,
        data?: any): Promise<T> {
        return this.call<T>(route, state, {data: data, method: "post"});
    }

    public static patch<T>(
        route: string,
        state: IReduxState,
        data?: any): Promise<T> {
        return this.call<T>(route, state, {data: data, method: "patch"});
    }

    public static delete<T>(
        route: string,
        state: IReduxState,
        data?: any): Promise<T> {
        return this.call<T>(route, state, {data: data, method: "delete"});
    }

    public static call<T>(
        route: string,
        state: IReduxState,
        props: ICallProps = {data: undefined, method: ""}): Promise<T> {
        return new Promise((resolve, reject) => {
            let aConfig: AxiosRequestConfig = {};
            if (props.method)
                aConfig.method = props.method;
            else
                aConfig.method = "get";
            aConfig.baseURL = config.baseURL;
            aConfig.url = route;
            if (props.data)
                aConfig.data = props.data;
            if (state && state.general.client.isAuthenticated())
                aConfig.headers = {authorization: "Bearer " + state.general.client.token};
            aConfig.responseType = "json";
            axios(aConfig)
                .then(
                    (response: AxiosResponse) => {
                        if (response && response.status === 200)
                            resolve(response.data as T);
                        else {
                            if (response)
                                reject(response.statusText);
                            else
                                reject("request failed");
                        }
                    },
                    (reason: AxiosError) => {
                        reject(reason);
                    });
        });
    }
}



// WEBPACK FOOTER //
// ./src/services/WebAPI.tsx